/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Control summary for the NIST CSF wizard (BASE catalog)
 * @export
 * @interface NistCsfWizardCatalogControlDto
 */
export interface NistCsfWizardCatalogControlDto {
    /**
     * Primary key of the catalog control (ComplianceControl id)
     * @type {string}
     * @memberof NistCsfWizardCatalogControlDto
     */
    id?: string;
    /**
     * OSCAL-style control identifier (e.g. gv.oc-1)
     * @type {string}
     * @memberof NistCsfWizardCatalogControlDto
     */
    controlId?: string;
    /**
     * Display title for the control
     * @type {string}
     * @memberof NistCsfWizardCatalogControlDto
     */
    controlTitle?: string;
    /**
     * Target maturity (1-5) from OSCAL property target-maturity-level, defaulting to 1 when absent or invalid
     * @type {number}
     * @memberof NistCsfWizardCatalogControlDto
     */
    targetMaturity?: number;
}

/**
 * Check if a given object implements the NistCsfWizardCatalogControlDto interface.
 */
export function instanceOfNistCsfWizardCatalogControlDto(value: object): value is NistCsfWizardCatalogControlDto {
    return true;
}

export function NistCsfWizardCatalogControlDtoFromJSON(json: any): NistCsfWizardCatalogControlDto {
    return NistCsfWizardCatalogControlDtoFromJSONTyped(json, false);
}

export function NistCsfWizardCatalogControlDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NistCsfWizardCatalogControlDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'controlTitle': json['controlTitle'] == null ? undefined : json['controlTitle'],
        'targetMaturity': json['targetMaturity'] == null ? undefined : json['targetMaturity'],
    };
}

export function NistCsfWizardCatalogControlDtoToJSON(json: any): NistCsfWizardCatalogControlDto {
    return NistCsfWizardCatalogControlDtoToJSONTyped(json, false);
}

export function NistCsfWizardCatalogControlDtoToJSONTyped(value?: NistCsfWizardCatalogControlDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'controlId': value['controlId'],
        'controlTitle': value['controlTitle'],
        'targetMaturity': value['targetMaturity'],
    };
}

